export const CTA_VARIANTS = ['custom', 'primary', 'secondary'];

const URL_SLASH_REGEXP = RegExp(/^\//);
export const normalizedUrl = (url) => {
  return URL_SLASH_REGEXP.test(url) ? url : `/${url}`;
};
